import React, { useState, useEffect } from 'react';
import api from '../../apiConnector'
import FieldSelect from './fieldSelect';

const FieldAssureurs = ({container,field}) => {

  const [assureurs, setAssureurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssureurs = async () => {
      try {
        console.log(`${api.backend}/cli/axa/assureurs.php`)
        const response = await fetch(`${api.backend}/cli/axa/assureurs.php`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        const data = await response.json();
        setAssureurs(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAssureurs();
  }, []); // Empty dependency array means this runs once on mount

  // 2. Conditional Rendering
  if (loading) return <p>Loading insurance providers...</p>;
  if (error) return <p>Error: {error}</p>;

  const options = Object.entries(assureurs).map(([code,name]) => ( {value:code,label:name} ))

  return <FieldSelect container={container} field={field} options={options}/>
};

export default FieldAssureurs;